import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

const VIDEO_ID = "0fSMXCWZHl0";

const VideoSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <section id="demo" className="relative py-20 md:py-28 overflow-hidden scroll-mt-24">
      {/* Starts at the same #006AD5 as FeaturesGrid's ending — no top bridge
          needed, the two blues already meet seamlessly. */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#006AD5] via-[#1a1a2e] to-[#1a1a2e]" />

      {/* Subtle radial glow */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 70% 50% at 50% 50%, rgba(0,128,255,0.08) 0%, transparent 70%)",
        }}
      />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-center mb-10"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight">
            Zobacz, jak to działa<span className="text-orange-400">.</span>
          </h2>
          <p className="mt-4 text-base md:text-lg text-white/60 max-w-2xl mx-auto">
            W 2 minuty dowiesz się, jak Viraluj pomaga tworzyć treści, które zdobywają zasięgi.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.15 }}
          className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/40"
          style={{
            background: "rgba(255, 255, 255, 0.05)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          {/* 16:9 responsive container */}
          <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
            {isLoaded ? (
              <iframe
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube.com/embed/${VIDEO_ID}?si=kxU1h9O33NC4GmW0&rel=0&autoplay=1`}
                title="Viraluj - zobacz jak to działa"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            ) : (
              <button
                type="button"
                className="absolute inset-0 w-full h-full cursor-pointer group"
                onClick={() => setIsLoaded(true)}
                aria-label="Odtwórz wideo"
              >
                {/* YouTube thumbnail — lightweight image instead of full iframe */}
                <img
                  src={`https://i.ytimg.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
                  alt="Viraluj - miniatura wideo"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />

                {/* Dark overlay for contrast */}
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors duration-300" />

                {/* Play button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-orange-500 flex items-center justify-center shadow-xl shadow-orange-500/30 group-hover:scale-110 transition-transform duration-300">
                    <Play className="w-7 h-7 md:w-9 md:h-9 text-white ml-1" fill="white" />
                  </div>
                </div>
              </button>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VideoSection;
